import React from "react";
import { Link } from "react-router-dom";

const VendorCard = ({
  title,
  category,
  people,
  img,
  handleBookModalChange,
  id,
}) => {
  return (
    <>
      <div class="card my-2">
        <div className="wedding_card_contaiener">
          <img src={img} class="card-img-top" alt="..." />
        </div>
        <div class="card-body">
          <h5 class="card-title">{title}</h5>
          <p class="wedding-text">
            <i class="fa fa-tag mr-3" aria-hidden="true"></i>
            <span> {category} </span>
          </p>
          <p class="wedding-text mt-2">
            {people ? (
              <>
                <i class="fa fa-users mr-3" aria-hidden="true"></i>
                <span>{people}</span>
              </>
            ) : null}
          </p>
          <div className="d-flex">
            <button
              class="btn btn-outline-primary mr-2 w-100 mt-2"
              data-toggle="modal"
              data-target="#BookNowModalBox"
              onClick={handleBookModalChange}
            >
              Request Pricing
            </button>

            <Link
              to={`/vendorDetail/${title?title:"Vendor Detail"}?id=${id}`}
              class="btn btn-primary w-100  mt-2"
            >
              See Details
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default VendorCard;
